import { FC, ReactNode } from "react";
import cx from 'classnames';
import './scss/toggle-button.scss';
import { MdOutlineClose } from "react-icons/md";

type Props = {
  checked: boolean;
  onClick: () => void;
  children: ReactNode;
};

const ToggleButton: FC<Props> = ({ checked, onClick, children }) => {
  return (
    <button
      className={cx("toggle-button", { active: checked })}
      onClick={onClick}
    >
      {children}
      {checked && <span className="ms-2 yettel-light-font"><MdOutlineClose /></span>}
    </button>
  );
};

export default ToggleButton;
